import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';
import firebase from 'firebase';

@Pipe({ name: 'firestoreTimestamp' })
export class FirestoreTimestampPipe implements PipeTransform {
  transform(value: firebase.firestore.Timestamp, format = 'YYYY-MM-DD'): string {
    return moment(value.toDate()).format(format);
  }
}